<template>
	<b-modal
		:visible="show"
		@hide="() => this.$emit('close')"
		hide-footer
		:title="'Add file' | translate"
	>
		<form @submit.prevent="addFile" class="modal-block">
			<input
				type="file"
				@change="uploadFiles"
				class="form-control-file  border border-primary rounded   mb-2"
			/>
			<button class="btn btn-primary" :disabled="!file">
				{{ 'Add' | translate }}
			</button>
		</form>
	</b-modal>
</template>

<script>
export default {
	name: 'modal-file',
	data: () => ({
		file: '',
	}),
	props: ['show'],
	methods: {
		close() {
			this.$emit('close')
		},
		uploadFiles(e) {
			if (!e.target.files.length) {
				this.file = ''
				return false
			}
			let file = e.target.files[0]
			let docs = new FormData()
			docs.append(file.name, file, file.name)
			this.file = docs
		},
		addFile() {
			let folder = !this.$store.state.storage.folder
				? ''
				: `?folder=${this.$store.state.storage.folder}`
			this.axios({
				method: 'post',
				url: `storage/files/${folder}`,
				headers: {
					'Content-Type': 'multipart/form-data',
				},
				data: this.file,
			}).then(response => {
				// If file uploaded add it to folder`s list
				this.$store.commit('changeStorageFiles', [
					...this.$store.state.storage.files,
					response.data,
				])
				this.close()
			})
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
input {
	padding: 10px;
}
</style>
